import { CURRENCY_CODE, CURRENCY_LOCALE } from "@/src/shared/constants/app";

/**
 * Format a numeric amount with the app-wide currency code.
 * Example: formatPrice(2500) → "BDT 2,500".
 *
 * Currency code/locale are driven by CURRENCY_CODE / CURRENCY_LOCALE in
 * `const/app.ts` so switching the entire app's currency is a one-line change.
 */
export function formatPrice(
  amount: number | null | undefined,
  options: { withCode?: boolean } = {},
): string {
  const { withCode = true } = options;
  const n = Number.isFinite(amount as number) ? (amount as number) : 0;
  const formatted = n.toLocaleString(CURRENCY_LOCALE);
  return withCode ? `${CURRENCY_CODE} ${formatted}` : formatted;
}
